import React, { Fragment, useContext, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import API from "../../../utils";
import { toast } from "react-toastify";
import { NotificationsContext } from "./notificationsContext";
import defalutimages from "../../../assets/images/user/user_default.jpg";

const Notifications = ({ notificationData, fetchNotificationData, fetchNotificationCount }) => {
  const navigate = useNavigate();
  const [apiResponse, setApiResponse] = useState(null);
  const { notifications, loading, fetchNotifications, markNotificationAsViewed } = useContext(NotificationsContext);
  const handleNotificationClick = async (link, contentType, id, redirectId) => {
  
    const success = await markNotificationAsViewed(id);
    if (success) {
      fetchNotificationData();
      fetchNotificationCount();
      switch (contentType) {
        case "posts":
          navigate(`/post-details/${redirectId}`);
          break;
        case "group":
          navigate(`/groups-view/${redirectId}`);
          break;
        case "video":
          navigate(`/video-details/${redirectId}`);
          break;
        case "event":
          navigate(`/event-details/${redirectId}`);
          break;
        case "friends":
          navigate(`/messages/${redirectId}`);
          break;
        default:
          navigate(link || "/");
          break;
      }
    }
  };

  const limitedNotifications = notificationData.slice(0, 7);
  const hasMoreNotifications = notificationData.length > 7;
  //   const limitedNotifications = notifications.slice(0, 7);
  //   const hasMoreNotifications = notifications.length > 7;

  return (
    <Fragment>
      <div>
        <ul className="notification-dropdown onhover-show-div p-0">
          <div className="selected notifications"></div>
          <div className="metadata">
            <div className="messages-inner">
              {limitedNotifications.length > 0 ? (
                limitedNotifications.map((notification, index) => (
                  <div key={index} className="ossn-notifications-all">
                  <a
  onClick={() =>
    handleNotificationClick(
      notification.link || "/",
      notification.contentType,
      notification.id,
      notification.notificationId
    )
  }
  className={notification.is_view === 0 ? "ossn-notification-unviewed" : ""}
>
                      <li>
                        <div className="notification-image">
                          <img src={notification?.comment_data?.sender_data?.profile_img || notification?.comment_data?.data?.posted_user?.profile_img || defalutimages} alt="User Avatar" />
                        </div>
                        <div className="notfi-meta">
                          <div className="data">
                            <strong>{notification.message}</strong> {notification.title}
                          </div>
                        </div>
                      </li>
                    </a>
                  </div>
                ))
              ) : (
                <div className="no-notifications text-center">No notifications found.</div>
              )}
            </div>
            {hasMoreNotifications && (
              <div className="bottom-all">
                <Link to="/notification/all">See All</Link>
              </div>
            )}
          </div>
        </ul>
      </div>
    </Fragment>
  );
};

export default Notifications;
